import type { ColorScheme, Theme } from '@tribeplatform/design-system/types'

export const getCssText = (theme: Theme, colorScheme: ColorScheme): string => {
  const colors = theme.colors[colorScheme]

  return Object.entries(colors).reduce(
    (result, [key, value]) => `${result}--bm-color-${key}: ${value};`,
    '',
  )
}

export const applyTheme = (
  theme: Theme,
  colorScheme: ColorScheme,
  element: HTMLElement,
) => {
  element.style.cssText = getCssText(theme, colorScheme)
}
